import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: (isChecked, isDisabled) => ({
    appearance: 'none',
    border: `1px solid`,
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    display: 'flex',
    boxSizing: 'content-box',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0',
    borderColor: colors.tertiaryBorder,
    backgroundColor: colors.primaryBackground,
    ':checked': {
      borderColor: colors.accentBorder,
      backgroundColor: colors.primaryBackground,
    },
    ':disabled': {
      borderColor: colors.ghostBorder,
      backgroundColor: colors.hoverBackground,
    },
    ':checked:disabled': {
      borderColor: colors.ghostBorder,
      backgroundColor: colors.primaryBackground,
    },
    ':hover': {
      borderColor: `${isChecked ? colors.accentBorder : colors.hoverBorder}`,
      backgroundColor: `${isChecked ? colors.primaryBackground : colors.hoverBackground}`,
    },
    '::before': {
      content: '',
      borderRadius: '50%',
      backgroundColor: `${isDisabled && isChecked ? colors.ghostBackground : isChecked ? colors.accentBackground : null}`,
    },
  }),
  //sizes
  small: {
    width: '14px', //захардкодил, так как в токенах таких размеров пока не было
    height: '14px', //захардкодил, так как в токенах таких размеров пока не было
    borderRadius: anatomy['borderRadiusL'],
    '::before': {
      width: '10px', //захардкодил, так как в токенах таких размеров пока не было
      height: '10px', //захардкодил, так как в токенах таких размеров пока не было
    },
  },
  medium: {
    width: anatomy['size-16'],
    height: anatomy['size-16'],
    borderRadius: anatomy['borderRadiusL'],
    '::before': {
      width: anatomy['size-12'],
      height: anatomy['size-12'],
    },
  },
  large: {
    width: '18px', //захардкодил, так как в токенах таких размеров пока не было
    height: '18px', //захардкодил, так как в токенах таких размеров пока не было
    borderRadius: anatomy['borderRadiusL'],
    '::before': {
      width: '14px', //захардкодил, так как в токенах таких размеров пока не было
      height: '14px', //захардкодил, так как в токенах таких размеров пока не было
    },
  },
});
